import { ThemeEngine, registerThemes } from '@vanialabs/ui-engine';

console.log("[TRACE] themeEngine.instance: module start");

/**
 * Single, app-wide ThemeEngine instance.
 *
 * This is the ONLY place in vania-mini-client that constructs a
 * ThemeEngine or calls registerThemes() — mirrors the single-seam
 * pattern the engine itself uses in its own registerThemes.ts.
 *
 * No `preferenceStore` is wired yet (Phase 1: no persistence). A Telegram
 * CloudStorage-backed adapter implementing `IThemeEnginePreferenceStore`
 * is a future addition, not part of this shell.
 */
export const themeEngine = new ThemeEngine({
  defaultThemeId: 'default',
});

console.log("[TRACE] ThemeEngine constructed", themeEngine);

const registerThemesResult = registerThemes(themeEngine);

// registerThemes()'s return type isn't visible from this app (it comes from
// @vanialabs/ui-engine). If it's ever made async, logging "finished"
// immediately after the call — without awaiting — would be a lie. Handle
// both cases explicitly so the trace is trustworthy either way.
if (typeof (registerThemesResult as unknown as PromiseLike<unknown>)?.then === 'function') {
  console.log("[TRACE] registerThemes returned a promise — awaiting before declaring 'finished'");
  Promise.resolve(registerThemesResult)
    .then(() => console.log("[TRACE] registerThemes finished (async)"))
    .catch((err) => console.error("[TRACE] registerThemes REJECTED", err));
} else {
  console.log("[TRACE] registerThemes finished (sync)");
}
